class componentTimer extends HTMLElement {

    constructor() {
        super();
        
        // Performance optimization: instance properties
        this.isSticky = false;
        this.scrollTimeout = null;
        this.container = null;
        this.observer = null;
        this.sentinel = null;
        this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)');
        this.isDesktop = this.desktopMediaQuery.matches;
        
        this.initCounter();

        // setTimeout(() => {
        //     console.log("collection__timer-wrapper element has zero height");
        //     // hide the ghost collection timer of collection__timer-wrapper element has zero height
        //     if (document.querySelector('.collection__timer-container--ghost') && document.querySelector('.collection__timer-wrapper') && document.querySelector('.collection__timer-wrapper').offsetHeight === 0) {
        //         document.querySelector('.collection__timer-container--ghost').style.height = '1vw';
        //     }
        // }, 1000);
    }

    /**
	 * Init counter
     * 
     * @return {undefined}
	 */
     initCounter() {
        let counter = document.querySelectorAll('[data-counter]');
        let collectionCounter = document.querySelector('.collection__timer-wrapper');

        counter.forEach(timer => {
            // Set the date we're counting down to
            let countDownDate = timer.dataset.date.trim();
            countDownDate = countDownDate.replace(/-/g, "/");
            countDownDate = Date.parse(countDownDate);
            // adding up the hours to end at the end of the day
            countDownDate = countDownDate + 86340000;

            // Update the count down every 1 second
            setInterval(this.countdown , 1000, countDownDate, timer); 

            if (collectionCounter) {
                this.applySticky(true);
                // Use IntersectionObserver instead of scroll events for better performance
                this.initStickyBehavior();
            }
        });
	}

    /**
	 * Init countdown
     *   
     * @param {countDownDate} countDownDate The date we're counting down to.
     * @param {timer} timer A timer object.
     * @return {undefined}
	 */
    countdown(countDownDate, timer) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
        let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();

        days = days.padStart(2, '0');
        hours = hours.padStart(2, '0');
        minutes = minutes.padStart(2, '0');
        seconds = seconds.padStart(2, '0');
        
        let dateString = timer.dataset.date.trim();

        if (dateString && !dateString.includes('T')) {
            dateString = dateString.replace(' ', 'T');
        }

        let date = new Date(dateString);

        let daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let dayOfWeek = daysOfWeek[date.getDay()];

        if (document.body.classList.contains('template-collection')) {
            // Display the result in the element
            timer.innerHTML = `<div class="collection__timer-text-wrapper">Ends <div class="collection__timer-wrapper--text">${dayOfWeek}</div></div>
            <div class="collection__timer-text-wrapper">${days} <div class="collection__timer-wrapper--text">day(s)</div></div>
            <div class="collection__timer-text-wrapper">${hours} <div class="collection__timer-wrapper--text">hrs</div></div>
            <div class="collection__timer-text-wrapper">${minutes} <div class="collection__timer-wrapper--text">min</div></div>
            <div class="collection__timer-text-wrapper">${seconds} <div class="collection__timer-wrapper--text">sec</div></div>`;
        } else if (days > 0)  {
            // Display the result in the element
            let numbers = days + "d " + hours + ":" + minutes + ":" +  seconds ;

            numbers =  '<span class="timer__numbers">'+ numbers +'</span>';

            if(timer.dataset.counterStart) {   
                timer.innerHTML = "Starts " + numbers;

            } else {
                timer.innerHTML = "Ends " + numbers;
            }

        } else {
            // Display the result in the element
            let numbers = hours + ":" + minutes + ":" +  seconds ;

            numbers =  '<span class="timer__numbers">'+ numbers +'</span>';

            if(timer.dataset.counterStart) {   
                timer.innerHTML = "Starts " + numbers;

            } else {
                timer.innerHTML = "Ends " + numbers;
            }
        }

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval();
            timer.innerHTML = timer.dataset.mensagemTimerOver;
        }
    }

    /**
	 * Initialize sticky behavior using Intersection Observer (more performant than scroll events)
     *   
     * @return {undefined}
	 */
    initStickyBehavior() {
        this.container = document.querySelector('.collection__timer-container');
        if (!this.container) return;

        // Set up media query listener for responsive behavior
        this.handleMediaChange = (e) => {
            this.isDesktop = e.matches;
        };
        this.desktopMediaQuery.addEventListener('change', this.handleMediaChange);

        // Create a sentinel element 30px from top to detect scroll position
        this.sentinel = document.createElement('div');
        this.sentinel.style.position = 'absolute';
        this.sentinel.style.top = '30px';
        this.sentinel.style.height = '1px';
        this.sentinel.style.width = '1px';
        this.sentinel.style.pointerEvents = 'none';
        this.sentinel.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.sentinel);

        // Use Intersection Observer for performant scroll detection
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    const shouldBeSticky = !entry.isIntersecting;
                    
                    // Only update if state actually changed
                    if (shouldBeSticky !== this.isSticky) {
                        // const delay = this.isDesktop ? 200 : 0;
                        const delay = 0;
                        clearTimeout(this.scrollTimeout);
                        
                        if (delay > 0) {
                            this.scrollTimeout = setTimeout(() => {
                                this.applySticky(shouldBeSticky);
                            }, delay);
                        } else {
                            this.applySticky(shouldBeSticky);
                        }
                    }
                });
            },
            { 
                threshold: 0,
                rootMargin: '0px'
            }
        );

        // Start observing
        this.observer.observe(this.sentinel);
    }

    /**
     * Apply sticky classes to DOM
     */
    applySticky(isSticky) {
        if (!this.container) return;
        
        // Check if state is actually changing
        if (isSticky === this.isSticky) {
            return;
        }
        
        // Toggle the classes
        this.container.classList.toggle('sticky', isSticky);
        document.body.classList.toggle('timer-sticky', isSticky);
        
        // Update the state
        this.isSticky = isSticky;
    }

    /**
     * Cleanup when component is removed
     */
    disconnectedCallback() {
        // Clean up observer
        if (this.observer) {
            this.observer.disconnect();
        }
        
        // Remove sentinel element
        if (this.sentinel && this.sentinel.parentNode) {
            this.sentinel.parentNode.removeChild(this.sentinel);
        }
        
        // Clear any pending timeouts
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        
        // Clean up media query listener
        if (this.handleMediaChange && this.desktopMediaQuery) {
            this.desktopMediaQuery.removeEventListener('change', this.handleMediaChange);
        }
    }
}

customElements.define('component-timer', componentTimer);

